/**
 * Time Range Selector Component
 *
 * Toggle group for selecting dashboard time range (1d, 3d, 7d, 30d)
 */

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import type { TimeRange } from '@/types/dashboard';

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
  disabled?: boolean;
}

export function TimeRangeSelector({
  value,
  onChange,
  disabled = false,
}: TimeRangeSelectorProps) {
  const handleChange = (newValue: string) => {
    // ToggleGroup returns empty string when deselecting, ignore that
    if (
      newValue &&
      (newValue === '1d' ||
        newValue === '3d' ||
        newValue === '7d' ||
        newValue === '30d')
    ) {
      onChange(newValue);
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={handleChange}
      disabled={disabled}
      variant="outline"
      aria-label="Select time range"
    >
      <ToggleGroupItem value="1d" aria-label="Last day">
        1d
      </ToggleGroupItem>
      <ToggleGroupItem value="3d" aria-label="Last 3 days">
        3d
      </ToggleGroupItem>
      <ToggleGroupItem value="7d" aria-label="Last 7 days">
        7d
      </ToggleGroupItem>
      <ToggleGroupItem value="30d" aria-label="Last 30 days">
        30d
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
